/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ConvoDefs from './defs.defs.js'

const $nsid = 'chat.bsky.convo.listConvos'

export { $nsid }

const main = l.query(
  $nsid,
  l.params({
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 100 }), 50),
    ),
    cursor: l.optional(l.string()),
    readState: l.optional(l.string<{ knownValues: ['unread'] }>()),
    status: l.optional(l.string<{ knownValues: ['request', 'accepted'] }>()),
  }),
  l.jsonPayload({
    cursor: l.optional(l.string()),
    convos: l.array(
      l.ref<ConvoDefs.ConvoView>((() => ConvoDefs.convoView) as any),
    ),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
